import React from 'react';
import Type from 'prop-types';
import { Divider, List, ListItem, ListItemText } from "@mui/material";
import {
  FormattedDate,
  FormattedNumber,
  FormDialog,
  PhoneNumberInline,
} from 'components';
import { fullDateFormat } from 'constants/dateFormats';
import { useTranslation } from 'hooks';
import styles from './PromiseForm.module.css';

const PromiseForm = (props) => {
  const {
    open,
    onClose,
    values: {
      employee,
      due,
      contactName,
      contactPhone,
      createdAt,
      comment,
      amount,
    },
  } = props;
  const { t } = useTranslation();

  return (
    <FormDialog
      title={t('promise')}
      open={open}
      onClose={onClose}
      hideDefaultButtons
      isModalMode
    >
      <List className={styles.list}>
        <ListItem>
          <ListItemText primary={employee} secondary={t('employee')} />
        </ListItem>
        <Divider />
        <ListItem>
          <ListItemText primary={contactName} secondary={t('contactPerson')} />
        </ListItem>
        <Divider />
        <ListItem>
          <ListItemText
            primary={<PhoneNumberInline phone={contactPhone} />}
            secondary={t('contactPhone')}
          />
        </ListItem>
        <Divider />
        <ListItem>
          <ListItemText
            primary={
              createdAt && (
                <FormattedDate
                  value={createdAt}
                  token={fullDateFormat}
                  variant="body1"
                />
              )
            }
            secondary={t('promiseCreatedDate')}
          />
        </ListItem>
        <Divider />
        <ListItem>
          <ListItemText primary={comment} secondary={t('comment')} />
        </ListItem>
        <Divider />
        <ListItem>
          <ListItemText
            primary={
              amount && (
                <FormattedNumber
                  classes={{ root: styles.amount }}
                  value={amount}
                  options={{
                    currency: 'RUB',
                    style: 'currency',
                    minimumFractionDigits: 0,
                    maximumFractionDigits: 0,
                  }}
                  color="textPrimary"
                  variant="body1"
                  component="span"
                />
              )
            }
            secondary={t('amount')}
          />
        </ListItem>
        <Divider />
        <ListItem>
          <ListItemText
            primary={
              due && (
                <FormattedDate
                  value={due}
                  token={fullDateFormat}
                  variant="body1"
                />
              )
            }
            secondary={t('promisedDate')}
          />
        </ListItem>
      </List>
    </FormDialog>
  );
};

PromiseForm.propTypes = {
  open: Type.bool.isRequired,
  onClose: Type.func.isRequired,
  values: Type.shape({
    employee: Type.string.isRequired,
    due: Type.string,
    contactName: Type.string,
    contactPhone: Type.string,
    createdAt: Type.string.isRequired,
    comment: Type.string,
    amount: Type.number,
  }).isRequired,
};

export default PromiseForm;
